import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT, AUTH_REFREESH } from '../actions/auth'
import axios from '@/axios'

const getField = (filed, user, def) => {
  if (user && filed in user) {
    return user[filed]
  }
  return def
}

const state = () => {
  const localUser = localStorage.getItem('user')
  const user = JSON.parse(localUser)
  const data = {
    roles: getField('roles', user, []),
    info: getField('info', user, {}),
    id: user ? user.id : 0,
    name: user ? user.name : 'oops',
    region: user ? user.region : {},
    region_title: user ? (user.region ? user.region.title : '') : '',
  }
  if (user && !user.info) {
    user.info = { publish_permission: false }
  }
  return {
    token: localStorage.getItem('user-token') || '',
    status: '',
    hasLoadedOnce: false,
    user: data,
  }
}

const getters = {
  isAuthenticated: (state) => !!state.token,
  authStatus: (state) => state.status,
}

function setCurrentUser(data) {}

const actions = {
  [AUTH_REQUEST]: ({ commit, dispatch }, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      axios({ url: '/auth/login', data: user, method: 'post' })
        .then((resp) => {
          localStorage.setItem('user', JSON.stringify(resp.data.user))
          localStorage.setItem('user-token', resp.data.token)
          localStorage.setItem('user-expire', resp.data.expire)
          localStorage.setItem(
            'user-region',
            resp.data.user.info ? resp.data.user.info.region.key : ''
          )
          localStorage.setItem(
            'user-region-title',
            resp.data.user.info ? resp.data.user.info.region.title : ''
          )
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + resp.data.token
          commit(AUTH_SUCCESS, resp)
          resolve(resp)
        })
        .catch((err) => {
          commit(AUTH_ERROR, err)
          localStorage.removeItem('user-token')
          reject(err)
        })
    })
  },
  [AUTH_REFREESH]: ({ commit, dispatch }, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      axios({ url: '/auth/refresh', data: user, method: 'post' })
        .then((resp) => {
          localStorage.setItem('user', JSON.stringify(resp.data.user))
          localStorage.setItem('user-token', resp.data.token)
          localStorage.setItem('user-expire', resp.data.expire)
          localStorage.setItem(
            'user-region',
            resp.data.user.info ? resp.data.user.info.region.key : ''
          )
          localStorage.setItem(
            'user-region-title',
            resp.data.user.info ? resp.data.user.info.region.title : ''
          )
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + resp.token
          commit(AUTH_SUCCESS, resp)
          resolve(resp)
        })
        .catch((err) => {
          commit(AUTH_ERROR, err)
          localStorage.removeItem('user-token')
          reject(err)
        })
    })
  },
  [AUTH_LOGOUT]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT)
      localStorage.removeItem('user-token')
      localStorage.removeItem('user-expire')
      localStorage.removeItem('user')
      localStorage.removeItem('user-region')
      localStorage.removeItem('user-region-title')
      resolve()
    })
  },
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    if (30 in resp.data.user.roles) {
      resp.data.user.info['publish_permission'] = true
    }
    state.status = 'success'
    state.token = resp.data.token
    state.user = resp.data.user

    // state.user.role = resp.data.user.role
    // state.user.name = resp.data.user.name
    // state.user = resp.data.user
    state.hasLoadedOnce = true
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = ''
    state.status = ''
    state.hasLoadedOnce = false
    state.user = { id: 0, role: 0, name: '' }
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
